<script>
  export let type;
  export let Style;
</script>

{#if type == 'overlay'}
  <div class="spinner-overlay d-flex align-items-center justify-content-center">
    <div
      class="spinner-border"
      role="status"
    >
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
{:else}
  <div
    class="spinner-border {Style}  "
    role="status"
  >
    <span class="visually-hidden">Loading...</span>
  </div>
{/if}

<style lang="scss">
  .spinner-border {
    width: 12px;
    height: 12px;
    border-width: 0.16em;
    position: relative;
    top: -4px;
  }
  .spinner-overlay {
    position: absolute;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.04);
    z-index: 100;
    height: 100%;
    left: 0;
    .spinner-border {
      width: 34px;
      height: 34px;
      border-width: 0.16em;
      color: $blue-color;
    }
  }
</style>
